<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 text-center>
        <h3 class="red--text mt-12 mb-12">
          <v-icon class="red--text mr-1">mdi-close</v-icon>
          <div>{{ $t('a') }}</div>
        </h3>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

export default {
  
}
</script>


<i18n>
{
  "fr": {
    "a": "Une erreur est survenue"
  },
  "en": {
    "a": "An error occured"
  }
}
</i18n>
